"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

/**
 * vanilla-cookieconsent plus its i18n is ~26 KB of ES5-transpiled JS (plus its
 * stylesheet) that Lighthouse flags under "legacy JavaScript". None of it is
 * needed to paint the page, so it is split out and pulled in once the browser
 * goes idle instead of riding along in the initial bundle.
 *
 * Deferring the banner does not defer the *consent decision*: Consent Mode v2
 * is defaulted to denied by the inline script in <head>, so nothing is tracked
 * in the window between first paint and the banner appearing.
 */
const CookieConsentBanner = dynamic(() => import("./cookie-consent"), {
  ssr: false,
});

export default function CookieConsentLoader() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // `timeout` guarantees the banner still arrives promptly on a busy main
    // thread; Safari < 16.4 has no requestIdleCallback, so fall back to a timer.
    if (typeof window.requestIdleCallback === "function") {
      const handle = window.requestIdleCallback(() => setShow(true), {
        timeout: 2000,
      });
      return () => window.cancelIdleCallback(handle);
    }

    const handle = window.setTimeout(() => setShow(true), 1000);
    return () => window.clearTimeout(handle);
  }, []);

  return show ? <CookieConsentBanner /> : null;
}
